import { getCoreApi } from '@/utility/getCoreApi';

import apiRequest from './apiRequest';

export interface ILocalityRentalReview {
  id: number;
  rental_summary: {
    slug: string;
    id: number;
    location: string;
    name: string;
    primary_image_url: string;
    rental_category: string;
    style: string;
  };
  reviewer: {
    avatar_url: string;
    first_name: string;
    id: number;
    last_name: string;
  };
  score: number;
  text: string;
  timestamp: string;
}

export const getLocalityRentalReviews = ({ lat, lng }: { lat: number; lng: number }) => {
  if (lng && lat) {
    const url = `${getCoreApi()}/reviews-for-locality?lat=${lat}&lng=${lng}`;
    return apiRequest<ILocalityRentalReview[]>({ url });
  }
  return [];
};
